module.exports = __webpack_public_path__ + "static/livesync_player_tags-502232e269b4b727902fab549efbbdbd.png";